import { ThemeProvider, BaseStyles } from '@primer/react'

import ColorModeSwitcher from './ColorModeSwitcher'
import TysmHeader from './tysmHeader'
import LegalPage from './LegalPage'
function App() {
    return (
        <ThemeProvider colorMode="auto">
            <BaseStyles>
                <TysmHeader />
                <LegalPage />
                <ColorModeSwitcher />
            </BaseStyles>
        </ThemeProvider>
    )
}

export default App
